import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IDocument } from 'document/document';
import { CoacheeProfileDocumentsController } from 'presentation/page/profile/coachee-profile/coachee-profile-documents/coachee-profile-documents.controller';

@Component({
	selector: 'spr-coachee-profile-documents-document',
	templateUrl: './coachee-profile-documents-document.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class:
			'flex md:items-center md:p-3 md:space-x-3 even:bg-grey-alabaster md:flex-row flex-col md:space-y-0 space-y-3',
	},
})
export class CoacheeProfileDocumentsDocumentComponent {
	@Input() public document: IDocument;
	constructor(public controller: CoacheeProfileDocumentsController) {}
}
